import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CobaltButtonModule, CobaltSpinnerModule } from '@msi/cobalt-prime';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface AddAgencyDialogData {
  serviceName: string;
}

@Component({
  selector: 'app-add-agency-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslocoDirective,
    TranslocoPipe,
    CobaltButtonModule,
    CobaltSpinnerModule
],
  templateUrl: './add-agency-modal.component.html',
  styleUrl: './add-agency-modal.component.scss',
})
export class AddAgencyModalComponent {
  @ViewChild('chipInput') chipInputRef!: ElementRef<HTMLInputElement>;

  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly config = inject<DynamicDialogConfig<AddAgencyDialogData>>(DynamicDialogConfig);

  public chips: string[] = [];
  public currentInput = '';

  public get serviceName(): string {
    return this.config.data?.serviceName ?? '';
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

  public submit(): void {
    this.commitInput();
    if (this.chips.length > 0) {
      this.dialogRef.close([...this.chips]);
    }
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key === ',' || event.key === ';' || event.key === 'Enter') {
      event.preventDefault();
      this.commitInput();
    } else if (event.key === 'Backspace' && this.currentInput === '' && this.chips.length > 0) {
      this.chips.pop();
    }
  }

  public commitInput(): void {
    const values = this.currentInput
      .split(/[,;]/)
      .map(v => v.trim())
      .filter(v => v.length > 0 && !this.chips.includes(v));
    this.chips.push(...values);
    this.currentInput = '';
  }

  public removeChip(index: number): void {
    this.chips.splice(index, 1);
  }

  public focusInput(): void {
    this.chipInputRef?.nativeElement?.focus();
  }
}
